export default "__VITE_ASSET__BjIccRfO__"